'use client';

import { useEffect } from 'react';

import { setHeaderScrolled } from '@/store/header.store';

const TOP_OFFSET = 64;
const SCROLL_DELTA = 8;

export function useHeaderAutoHide(enabled: boolean) {
  useEffect(() => {
    if (!enabled) {
      setHeaderScrolled(false);
      return;
    }

    let lastScrollY = window.scrollY;
    let ticking = false;

    const update = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= TOP_OFFSET) {
        setHeaderScrolled(false);
      } else if (Math.abs(currentScrollY - lastScrollY) > SCROLL_DELTA) {
        setHeaderScrolled(currentScrollY > lastScrollY);
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    const handleScroll = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      setHeaderScrolled(false);
    };
  }, [enabled]);
}
